import React from "react";
import { ITkAmountInputProps } from "../../../type/componentsType/TkAmountInput";
import TkLabelText from "../../atoms/TkLabelText";
import { InputAdornment } from "@mui/material";

/**
 * 金額入力コンポーネント
 * @param {ITkAmountInputProps} props - プロパティ
 * @param {Function} props.onChange - 入力値変更時のコールバック関数
 * @param {boolean} props.fullWidth - 幅を100%にするかどうか
 */
const TkAmountInput: React.FC<ITkAmountInputProps> = (props) => {
  const {
    onChange,
    fullWidth,
    label,
    wantToSetValue,
    size,
    inputProps,
    error,
    errorMessage,
    disabled,
    defaultValue,
    onlyNumber = true,
    useNumberValue = true,
    useDefault,
    innerText = "円",
    onGetInputValue,
    ...rest
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value === "") {
      const newObj = {
        target: {
          value: undefined,
        },
      } as any;
      onChange && onChange(newObj as React.ChangeEvent<HTMLInputElement>);
      onGetInputValue &&
        onGetInputValue(newObj as React.ChangeEvent<HTMLInputElement>);
      return;
    }

    const convertedValue = isNaN(Number(value)) ? value : Number(value);

    const newObj = {
      target: {
        value: typeof convertedValue === "number" ? convertedValue : value,
      },
    };

    onChange && onChange(newObj as React.ChangeEvent<HTMLInputElement>);
    onGetInputValue &&
      onGetInputValue(newObj as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <TkLabelText
      error={error}
      helperText={errorMessage}
      isNumberFormat
      onlyNumber={onlyNumber}
      useNumberValue={useNumberValue}
      fullWidth={fullWidth}
      wantToSetValue={wantToSetValue}
      defaultValue={defaultValue}
      useDefault={useDefault}
      label={label}
      size={size}
      onChange={handleChange}
      disabled={disabled}
      inputProps={{
        ...inputProps,
        style: { textAlign: "end" },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">{innerText}</InputAdornment>
        ),
      }}
      {...rest}
    />
  );
};

export default TkAmountInput;
